"use strict";

exports.__esModule = true;
exports.ElementEditorHorizontalToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _ControlGroups = require("../ControlGroups");
var _Theme = require("../../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ToolbarContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorHorizontalToolbar__ToolbarContainer",
  componentId: "sc-m8jrna-0"
})(["grid-area:toolbar;display:flex;justify-content:stretch;background:", ";.", " + .", "{margin-right:1rem;}.", "{flex:1;border:none;}"], (0, _Theme.val)("ToolbarBackground"), _core.Classes.BUTTON_GROUP, _core.Classes.BUTTON_GROUP, _core.Classes.BUTTON);

/**
 * Shows a horizontal toolbar of element controls.
 */
var ElementEditorHorizontalToolbar = exports.ElementEditorHorizontalToolbar = /*#__PURE__*/function (_Component) {
  function ElementEditorHorizontalToolbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementEditorHorizontalToolbar, _Component);
  var _proto = ElementEditorHorizontalToolbar.prototype;
  _proto.render = function render() {
    var elementEditor = this.props.elementEditor;
    var controlPaths = elementEditor.getControlPaths();
    return /*#__PURE__*/_react["default"].createElement(ToolbarContainer, {
      "data-testid": "ElementEditorHorizontalToolbar"
    }, /*#__PURE__*/_react["default"].createElement(_ControlGroups.ElementFontControlGroup, {
      controlPaths: controlPaths,
      elementEditor: elementEditor
    }), /*#__PURE__*/_react["default"].createElement(_ControlGroups.ElementColorControlGroup, {
      controlPaths: controlPaths,
      elementEditor: elementEditor
    }), /*#__PURE__*/_react["default"].createElement(_ControlGroups.ElementClipboardControlGroup, {
      elementEditor: elementEditor
    }), /*#__PURE__*/_react["default"].createElement(_ControlGroups.ElementUndoControlGroup, {
      elementEditor: elementEditor
    }));
  };
  return ElementEditorHorizontalToolbar;
}(_react.Component);